export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.c18c47c4.jpg";